import React from "react";
import { Box, Button, Checkbox, FormControlLabel, Typography } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Controller, useFormContext } from "react-hook-form";
import { SortableList } from "shared/SortableList";
import { SortableItem } from "shared/SortableItem";
import TranslatedTextField from "./TranslatedTextField";
import { LessonFormData, emptyLocalizedText } from "../types";
import { useSortableFieldArray } from "../hooks/useSortableFieldArray";
import { useActiveLocale } from "../ActiveLocaleContext";

type Props = { partIndex: number; questionIndex: number };

const AnswersSection: React.VFC<Props> = ({ partIndex, questionIndex }) => {
  const { control } = useFormContext<LessonFormData>();
  const { activeLocale } = useActiveLocale();
  const answersName = `parts.${partIndex}.questions.${questionIndex}.answers` as const;
  const { ids, fields, onDragEnd, append, remove } = useSortableFieldArray(answersName);

  return (
    <Box mt={1}>
      <Box display="flex" alignItems="center">
        <Typography variant="subtitle2">Answers</Typography>
        <Button size="small" startIcon={<Add />} onClick={() => append({ correct: false, text: emptyLocalizedText() })}>
          Add answer
        </Button>
      </Box>
      <SortableList items={ids} onDragEnd={onDragEnd}>
        {fields.map((_f, ai) => (
          <SortableItem key={ids[ai]} id={ids[ai]} accordion label={`Answer ${ai + 1}`} onRemove={() => remove(ai)}>
            <Controller
              control={control}
              name={`${answersName}.${ai}.correct` as const}
              render={({ onChange, value }) => (
                <FormControlLabel
                  control={<Checkbox checked={!!value} onChange={e => onChange(e.target.checked)} />}
                  label="Correct answer"
                />
              )}
            />
            <Controller
              control={control}
              name={`${answersName}.${ai}.text` as const}
              render={({ onChange, value }) => (
                <TranslatedTextField
                  label="Answer text"
                  value={value ?? emptyLocalizedText()}
                  onChange={onChange}
                  activeLocale={activeLocale}
                />
              )}
            />
          </SortableItem>
        ))}
      </SortableList>
    </Box>
  );
};

export default AnswersSection;
